import React, { Component } from 'react';

class RuntimeConfigErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('RuntimeConfig Error Boundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="runtime-config-banner runtime-config-banner-error" data-testid="runtime-config-error-boundary">
          <p>Something went wrong loading Runtime Config.</p>
          <button type="button" onClick={this.handleRetry}>Try Again</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RuntimeConfigErrorBoundary;
